import AuthorizationsListPage from './AuthorizationsListPage';
import AuthorizedTransactionDetailsPage from './AuthorizationDetailsPage';

export { AuthorizationsListPage, AuthorizedTransactionDetailsPage };

export default AuthorizationsListPage;
